// Plain (non-React) event bus so modules like the axios client can push toasts
// without importing React context — Toast.jsx subscribes to render them.
let listeners = [];
let nextId = 1;

export function subscribeToasts(listener) {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}

export function pushToast({ type = 'info', message }) {
  const toast = { id: nextId++, type, message };
  listeners.forEach((listener) => listener(toast));
  return toast;
}
